import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-telegram', 'BrandTelegram', [["path",{"d":"M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"}]]);